import { useState } from 'react';
import { Box, CircularLoader, Column } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useCobConfig } from "../../../../CobConfigContext";
import VideoPlayer from "../../../../../../components/VideoPlayer/VideoPlayer";
import { videoUrl } from "../../../../../../models/intro-video";
import styles from "./introVideo.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const {
  IntroVideoTestIds
} = getTestIds();
export const IntroVideo = () => {
  const {
    relationship
  } = useCobConfig();
  const {
    introVideo
  } = relationship;
  const [isLoading, setIsLoading] = useState(true);
  const url = introVideo && videoUrl(introVideo);
  if (!url) {
    throw new Error('Intro Video does not have URL');
  }
  const handleReady = () => {
    setIsLoading(false);
  };
  return /*#__PURE__*/_jsxs(Column, {
    className: styles.root,
    children: [isLoading && /*#__PURE__*/_jsx(Box, {
      className: styles.loaderWrapper,
      testId: IntroVideoTestIds.Loader(),
      children: /*#__PURE__*/_jsx(CircularLoader, {})
    }), /*#__PURE__*/_jsx(Box, {
      className: styles.videoWrapper,
      testId: IntroVideoTestIds.Video(),
      style: {
        display: isLoading ? 'none' : 'flex'
      },
      children: /*#__PURE__*/_jsx(VideoPlayer, {
        url: url,
        height: '100%',
        onReady: handleReady
      })
    })]
  });
};